import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import mgmtSections from "src/services/mgmtSections";
import Result from "./Result";

const SectionsList = () => {
  const [sections, setSections] = useState([]);

  const user = useSelector(
    (state) => state?.account?.user
  );

  const customerId = user?.customerId;

  const fetchSections = async () => {
    try {
      if (!customerId) return;

      const response =
        await mgmtSections.getSections(customerId);

      console.log("Sections Response:", response);

      const sectionList =
        response?.data?.productSections || [];

      setSections(sectionList);
    } catch (error) {
      console.error(
        "Failed to fetch sections:",
        error
      );

      setSections([]);
    }
  };

  useEffect(() => {
    fetchSections();
  }, [customerId]);

  return (
    <Result
      sections={sections}
      fetchSections={fetchSections}
    />
  );
};

export default SectionsList;